<p class="modal-title">Mute User</p>
<div class="body flex flex-col">
  <div class="user flex items-center">
    <img
      class="user-avatar"
      [src]="user()?.avatar"
      loading="lazy"
      width="32"
      height="32"
      [alt]="user.name + ' steam profile avatar'"
    />

    <div class="user-details">
      <p class="user-name">{{ user()?.name }}</p>
      <p class="user-steamid">STEAMID: {{ user()?.steamid }}</p>
    </div>

    <svg-icon class="bg" src="assets/images/ui-effects/background-vector.svg" />
  </div>

  <form  [formGroup]="muteForm" (ngSubmit)="onSubmit()" #muteFormRef="ngForm">
    <app-form-field
      [label]="'Duration in minutes'"
      [formControl]="time"
      [errorType]="'outline'"
      [id]="'time'"
      [submitting]="false"
      [placeholder]="'Enter Duration...'"
      [error]="
        !time.valid && muteFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Reason'"
      [formControl]="reason"
      [errorType]="'outline'"
      [id]="'reason'"
      [submitting]="false"
      [placeholder]="'Enter Reason...'"
      [error]="
        !reason.valid && muteFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <button class="button button--style-yellow h-32 padding-x-12" type="submit">
      Mute user
    </button>
  </form>
</div>
